import { useQueryErrorResetBoundary } from "@tanstack/react-query";
import { type ErrorComponentProps, Link, useRouter } from "@tanstack/react-router";
import { Compass } from "lucide-react";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { EmptyState } from "./empty-state";
import { ErrorPanel } from "./query-state";

export function RouteErrorPage({ error, reset }: ErrorComponentProps) {
  const router = useRouter();
  const { reset: resetQueries } = useQueryErrorResetBoundary();
  useEffect(() => resetQueries(), [resetQueries]);
  return (
    <div className="p-5">
      <ErrorPanel
        error={error}
        onRetry={() => {
          reset();
          void router.invalidate();
        }}
      />
    </div>
  );
}

export function NotFoundPage({
  title = "Page not found",
  description = "There is no console page at this address.",
}: {
  title?: string;
  description?: string;
}) {
  return (
    <EmptyState
      icon={Compass}
      title={title}
      description={description}
      className="py-20"
      action={
        <Button size="sm" variant="outline" nativeButton={false} render={<Link to="/overview" />}>
          Go to overview
        </Button>
      }
    />
  );
}
